// Diagnostic logging helpers for the Facebook account-setup flow.
// Enable from the browser console:
//   localStorage.setItem('fbDebug', 'true'); location.reload();
// Or append ?fbDebug=true to the URL.

const FB_DEBUG = (() => {
  try {
    if (typeof window === 'undefined') return false;
    if (window.localStorage && window.localStorage.getItem('fbDebug') === 'true')
      return true;
    return (window.location.search || '').indexOf('fbDebug=true') !== -1;
  } catch (e) {
    return false;
  }
})();

export const isFbDebug = () => FB_DEBUG;

// eslint-disable-next-line no-console
export const fbLog = (...args) => FB_DEBUG && console.debug('[FB Setup]', ...args);

// Strip access_token-like fields so logs are safe to share.
export const redact = value => {
  if (!value || typeof value !== 'object') return value;
  if (Array.isArray(value)) return value.map(redact);
  const out = {};
  Object.keys(value).forEach(k => {
    if (/access_token|accessToken|token/i.test(k)) {
      out[k] = value[k] ? `<redacted:${String(value[k]).length} chars>` : value[k];
    } else if (value[k] && typeof value[k] === 'object') {
      out[k] = redact(value[k]);
    } else {
      out[k] = value[k];
    }
  });
  return out;
};
